// extracted by mini-css-extract-plugin
export default {"control":"Product_control__Hv4rd","richText":"Product_richText__krgKF"};